const IsDisplayCollectionSummaryMixin = {
	computed: {
		selectedService(){ 
            return this.$store.getters.GET_BOOKING_STATE.selectedService
        },
		isDisplayCollectionSummary() {
            var multipleCollectionSetting = !this.isMultipleServiceBookingEnabled ? this.$store.getters.GET_ACTIVE_MULTIPLE_COLLECTION_SETTING : this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_OTHER_CURRENT_BOOKING_STATE;
            if(!this.selectedService || !multipleCollectionSetting){
                return false
            }
            else if(this.selectedService.is_paid == 1){ // Free
                return multipleCollectionSetting.per_waste_summary == 1
            }
            else if(this.selectedService.is_paid == 2){ // Paid
                return multipleCollectionSetting.per_waste_paid == 1

            }
        },
	}
};

module.exports = IsDisplayCollectionSummaryMixin;